import React, { useEffect, useMemo } from "react";
import { UtilsUser } from "../../utils/UtilsUser";
import DigitalLegacyAuth from "../../pages/nonauth/DigitalLegacyAuth/DigitalLegacyAuth";
import { ApplicationState } from "../../store";
import { UserState } from "../../store/reducers/user-reducer";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { AUTHENTICATED_ROUTES } from "../../configs/routes";
import { URLS } from "../../constants/urls";
import { deepLinkService } from "../../deeplink/DeepLinkService";

interface Props {
  children?: React.ReactNode;
}

const DeepLinkChecker: React.FC<Props> = (props) => {
  const currentURL = window.location.pathname;
  const { pathname } = useLocation();

  const { userCountryCode } = useSelector<ApplicationState, UserState>(
    (state) => state.user
  );

  const result = useMemo(
    () => deepLinkService.resolve(currentURL),
    [currentURL]
  );

  const isDLRequestDeepLink =
    result.status === "VALID" && result.deepLink.type === "SPDL";

  useEffect(() => {
    // Save deep link for any authenticated route when user is not logged in.
    // This persists the full intended destination (including ticket segments)
    // to localStorage, surviving SA portal cross-domain redirects.
    if (!UtilsUser.isUserLoggedIn() && result.status === "VALID") {
      deepLinkService.save(result.deepLink);
    }
  }, [pathname, userCountryCode]);

  // IF DEEPLINK is Digital Legacy and user is not yet LOGGED IN, REDIRECT to DL REDIRECT PAGE
  if (isDLRequestDeepLink && !UtilsUser.isUserLoggedIn()) {
    return <DigitalLegacyAuth />;
  }
  // IF NORMAL DEEPLINK: RETURN CHILDREN COMPONENTS
  return <>{props.children}</>;
};

export default DeepLinkChecker;
